import React, { useReducer, createContext, useContext } from "react";
import { uuid } from "../helpers/commonFunction";

export interface IToast {
  id: string;
  type: string;
  message: string;
}
type Action = { type: string; payload: any };
type Dispatch = (action: Action) => void;
type State = { toasts: IToast[] };
type ToastProvideProps = { children: React.ReactNode };

const ToastContext =
  createContext<{ state: State; dispatch: Dispatch } | undefined>(undefined);

const toastReducer = (state: State, action: Action) => {
  switch (action.type) {
    case "add": {
      return { toasts: [...state.toasts, action.payload] };
    }
    case "remove": {
      const updatedToasts = state.toasts.filter(
        (toast) => toast.id !== action.payload
      );
      return { toasts: updatedToasts };
    }
    default: {
      return state;
    }
  }
};

const ToastProvider = ({ children }: ToastProvideProps) => {
  const [state, dispatch] = useReducer(toastReducer, { toasts: [] });
  const value = { state, dispatch };

  return (
    <ToastContext.Provider value={value}>{children}</ToastContext.Provider>
  );
};

const useToast = () => {
  const context = useContext(ToastContext);

  if (context === undefined) {
    throw new Error("useToast must be used within a ToastProvider");
  }

  return context;
};

// toast actions
const addToast = (message: string, toastType: string) => ({
  type: "add",
  payload: {
    id: uuid(),
    type: toastType,
    message,
  },
});

const removeToast = (toastId: string) => ({
  type: "remove",
  payload: toastId,
});

export { ToastProvider, useToast, addToast, removeToast };
